"use client";

import CloudflareTurnstile from "@/components/CloudflareTurnstile";

interface Props {
    siteKey: string;
}

export default function TurnstileClient({ siteKey }: Props) {
    if (!siteKey) return null;
    return (
        <div className="mt-4">
            <CloudflareTurnstile siteKey={siteKey} />
        </div>
    );
}
